import styled from 'styled-components/native';

import { getTheme } from 'lib/styles/getTheme';

export const TextInput = styled.TextInput`
  font-family: ${getTheme('text.fontFamily')};
  font-style: italic;
`;
